export interface Progresso {
  pct: number // 0..100, inteiro -- vai direto para o width da barra
  atingida: boolean
}

// ⚠ O `pct` e SO para a barra, e por isso e travado em 100: uma barra de 150%
// vaza do cartao no celular. O numero realizado continua sendo mostrado inteiro
// ao lado, sem teto -- se ela vendeu 150% da meta, ela tem de ver isso.
export function progressoDaMeta(feito: number, alvo: number): Progresso {
  if (alvo <= 0) return { pct: 0, atingida: false }
  const bruto = (feito / alvo) * 100
  return { pct: Math.round(Math.min(100, bruto)), atingida: bruto >= 100 }
}
